// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ci-0";
export var fileCarousel = "_ci-2";
export var removeFileButton = "_ci-1";